import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '../components/Navigation';
import '../styles/pages/more.css';

const MENU_ITEMS = [
    { icon: '🌸', label: 'Guardería',   sub: 'Visitas activas y kennels',         to: '/daycare' },
    { icon: '🏨', label: 'Hotel',       sub: 'Reservas y huéspedes',              to: '/hotel' },
    { icon: '🩺', label: 'Veterinaria', sub: 'Citas y exámenes',                  to: '/vet' },
    { icon: '✂️', label: 'Estética',   sub: 'Reservas',                          to: '/grooming' },
    { icon: '🚐', label: 'Happy Bus',   sub: 'Transporte de perros',             to: '/happy-bus' },
    { icon: '🛒', label: 'Ventas',      sub: 'Historial y tickets',              to: '/pos' },
    { icon: '👥', label: 'Propietarios', sub: 'Directorio de contactos',          to: '/owners' },
    { icon: '📦', label: 'Paquetes',    sub: 'Paquetes de guardería',             to: '/daycare/packages' },
    { icon: '⚙️', label: 'Configuración', sub: 'Cuenta, personal, notificaciones', to: '/settings' },
];

export default function More() {
    const navigate = useNavigate();
    const { user, role, logout } = useAuth();

    const initials = (user?.username || role || '??').slice(0, 2).toUpperCase();
    const displayName = user?.username || role || 'User';
    const displayRole = role
        ? role.charAt(0).toUpperCase() + role.slice(1)
        : '';

    return (
        <div className="more-container">
            <Navigation />
            <main className="more-main">

                <div className="more-header">
                    <h1 className="more-title">Más</h1>
                </div>

                {/* Services menu card */}
                <div className="more-card">
                    {MENU_ITEMS.map((item, i) => (
                        <button
                            key={i}
                            className="more-item"
                            style={{
                                borderBottom: i < MENU_ITEMS.length - 1
                                    ? '1px solid #ECE6F2'
                                    : 'none',
                            }}
                            onClick={() => navigate(item.to)}
                        >
                            <div className="more-item-icon">{item.icon}</div>
                            <div className="more-item-text">
                                <span className="more-item-label">{item.label}</span>
                                <span className="more-item-sub">{item.sub}</span>
                            </div>
                            <span className="more-item-arrow">›</span>
                        </button>
                    ))}
                </div>

                {/* Account section */}
                <div className="more-section-label">Cuenta</div>

                <div className="more-account-card">
                    <div className="more-account-avatar">{initials}</div>
                    <div className="more-account-info">
                        <span className="more-account-name">{displayName}</span>
                        <span className="more-account-role">{displayRole}</span>
                    </div>
                    <button
                        className="more-logout-btn"
                        onClick={logout}
                        aria-label="Cerrar sesión"
                        title="Cerrar sesión"
                    >
                        ↪
                    </button>
                </div>

            </main>
        </div>
    );
}
